import { Contact } from "@/types/contacts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Building2, Mail, Phone } from "lucide-react";

interface ContactStatsCardsProps {
  contacts: Contact[];
}

export function ContactStatsCards({ contacts }: ContactStatsCardsProps) {
  const totalContacts = contacts.length;
  const totalCompanies = new Set(contacts.map(c => c.company)).size;
  const contactsWithEmail = contacts.filter(c => c.email).length;
  const contactsWithPhone = contacts.filter(c => c.cellPhone || c.phone).length;

  const stats = [
    {
      title: "Total de Contatos",
      value: totalContacts,
      icon: Users,
      description: "Contatos cadastrados",
    },
    {
      title: "Empresas",
      value: totalCompanies,
      icon: Building2,
      description: "Empresas únicas",
    },
    {
      title: "Com E-mail",
      value: contactsWithEmail,
      icon: Mail,
      description: "Contatos com e-mail",
    },
    {
      title: "Com Telefone",
      value: contactsWithPhone,
      icon: Phone,
      description: "Contatos com telefone",
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={index}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {stat.title}
              </CardTitle>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">
                {stat.description}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
